import { useCommonData } from '@/hooks';

// 引入腾讯地图sdk
export const initTencentMapApi = () => {
	return new Promise((resolve, reject) => {
		function hasTencentMapApi() {
			let nodeList = document.querySelectorAll('script');
			return (
				Array.from(nodeList).filter(node => node.src && node.src.indexOf('https://map.qq.com/api/') === 0)
					.length > 0
			);
		}

		function loadTencentMapApi() {
			const proSrc = 'https://map.qq.com/api/gljs?v=1.exp&key=YW2BZ-VQZC4-7N4UQ-FRKJ5-7HESZ-ECFE4';
			const script = document.createElement('script');
			script.src = proSrc;
			document.body.appendChild(script);
			script.onload = () => {
				resolve(true);
			};
			script.onerror = () => {
				reject(false);
			};
		}
		if (!hasTencentMapApi()) {
			loadTencentMapApi();
		} else {
			resolve(true);
		}
	});
};

export const TMapAddToLat = address => {
	return new Promise(function (resolve, _reject) {
		console.log('🚀 ~ address:', address);
		const url =
			'https://apis.map.qq.com/ws/geocoder/v1/?address=' +
			address +
			'&key=YW2BZ-VQZC4-7N4UQ-FRKJ5-7HESZ-ECFE4&output=jsonp&callback=handleResponse';
		const script = document.createElement('script');
		script.src = url;
		window.handleResponse = function (data) {
			console.log('🚀 ~ window.handleResponse ~ data:', data);
			resolve(data.result);
			// 删除script标签
			document.body.removeChild(script);
		};
		document.body.appendChild(script);
	});
};

/**
 * 联系信息相关的 hook
 */
export function useContactInformation() {
	const { isDarkTheme } = useCommonData();

	/**
	 * 创建地图标记和监听器（公共逻辑）
	 * @param {object} map - 地图实例
	 */
	const createMapMarker = async map => {
		const markerGeo = {
			id: 'center',
			position: map.getCenter()
		};
		// 创建一个位于地图中心点的marker
		const markerLayer = new window.TMap.MultiMarker({
			map: map,
			geometries: [markerGeo]
		});
		// 监听中心点变化事件，更新marker的位置
		map.on('center_changed', () => {
			markerGeo.position = map.getCenter();
			markerLayer.updateGeometries([markerGeo]);
		});
		return map;
	};

	/**
	 * 初始化腾讯地图（亮色主题）
	 * @param {string} containerID - 地图容器的 DOM ID
	 * @param {string} address - 地址
	 * @param {number} zoom - 缩放级别
	 */
	const initTencentMapLight = async (containerID, address, zoom = 17) => {
		const hasTencentMapApi = await initTencentMapApi();
		if (!hasTencentMapApi) return;

		zoom = !address ? 12 : zoom;
		address = address || '中国北京市';

		const res = await TMapAddToLat(address);
		const { lat, lng } = res?.location || {};
		if (!lat || !lng) return;

		const center = new window.TMap.LatLng(lat, lng); //设置中心点坐标
		//初始化地图（亮色主题，不设置 mapStyleId）
		const map = new window.TMap.Map(containerID, {
			zoom: zoom, //设置地图缩放级别
			center: center, //设置地图中心点坐标

			draggable: false,
			touchZoomable: false,
			scrollable: false
		});
		return createMapMarker(map);
	};

	/**
	 * 初始化腾讯地图（暗色主题）
	 * @param {string} containerID - 地图容器的 DOM ID
	 * @param {string} address - 地址
	 * @param {number} zoom - 缩放级别
	 */
	const initTencentMapDark = async (containerID, address, zoom = 17) => {
		const hasTencentMapApi = await initTencentMapApi();
		if (!hasTencentMapApi) return;

		zoom = !address ? 12 : zoom;
		address = address || '中国北京市';

		const res = await TMapAddToLat(address);
		const { lat, lng } = res?.location || {};
		if (!lat || !lng) return;

		const center = new window.TMap.LatLng(lat, lng); //设置中心点坐标
		//初始化地图（暗色主题，设置 mapStyleId: 'style1'）
		const map = new window.TMap.Map(containerID, {
			zoom: zoom, //设置地图缩放级别
			center: center, //设置地图中心点坐标
			mapStyleId: 'style1',

			draggable: false,
			touchZoomable: false,
			scrollable: false
		});
		return createMapMarker(map);
	};

	const setMapStyle = (map, styleId) => {
		map && map.setMapStyleId(styleId);
	};

	/**
	 * 初始化腾讯地图（兼容旧版本，默认使用亮色主题）
	 * @param {string} containerID - 地图容器的 DOM ID
	 * @param {string} address - 地址
	 * @param {number} zoom - 缩放级别
	 */
	const initTencentMap = async (containerID, address, zoom = 17) => {
		if (!containerID) return;

		const map = await initTencentMapLight(containerID, address, zoom);

		const isDark = isDarkTheme.value;
		if (isDark) {
			setMapStyle(map, 'style1');
		}

		const mapWrap = document.getElementById(containerID);
		if (mapWrap) {
			const afterMapElement = mapWrap.querySelector('canvas+div:last-child');
			afterMapElement.style.display = 'none';
		}

		return map;
	};

	return {
		initTencentMapLight,
		initTencentMapDark,
		initTencentMap,
		setMapStyle
	};
}
